"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconSlider = void 0;
var React = require("react");
var Slider_1 = require("@material-ui/core/Slider");
var FalconSlider = /** @class */ (function (_super) {
    __extends(FalconSlider, _super);
    function FalconSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderMinMax = function () {
            return (React.createElement("div", { className: "d-flex justify-content-between" },
                React.createElement("div", { className: "text-left font-weight-extra-light" },
                    "min.",
                    React.createElement("div", null, _this.formatValueText(_this.props.minValue))),
                React.createElement("div", { className: "text-right font-weight-extra-light" },
                    "max.",
                    React.createElement("div", null, _this.formatValueText(_this.props.maxValue)))));
        };
        _this.setValue = function (event, value) {
            if (value) {
                _this.props.returnValue(value);
                _this.hideDragElement();
            }
        };
        _this.formatValueText = function (value) {
            return "\u00A3".concat(value ? value.toLocaleString() : _this.props.defaultValue.toLocaleString());
        };
        _this.showDragElement = function () {
            var element = document.getElementsByClassName("MuiSlider-thumb")[0];
            var dragElement = document.createElement("span");
            dragElement.className = "thumb-drag";
            element.firstChild.insertBefore(dragElement, element.nextSibling);
        };
        _this.hideDragElement = function () {
            var dragElement = document.getElementsByClassName("thumb-drag")[0];
            dragElement && dragElement.remove();
        };
        return _this;
    }
    FalconSlider.prototype.componentDidMount = function () {
        !this.props.hideDrag && this.showDragElement();
    };
    FalconSlider.prototype.render = function () {
        return (React.createElement("div", { className: "falcon-slider ".concat(this.props.className) },
            React.createElement(Slider_1.default, { "aria-labelledby": "discrete-slider", valueLabelDisplay: "on", onChangeCommitted: this.setValue, valueLabelFormat: this.formatValueText, defaultValue: this.props.defaultValue, step: this.props.step, min: this.props.minValue, max: this.props.maxValue, marks: true }),
            this.renderMinMax()));
    };
    return FalconSlider;
}(React.Component));
exports.FalconSlider = FalconSlider;
//# sourceMappingURL=FalconSlider.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/FalconSlider.js
// module id = 1072
// module chunks = 0